"use client";
import React, { useEffect, useState } from "react";
import HomeIcon from "@mui/icons-material/Home";
import RefreshIcon from "@mui/icons-material/Refresh";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Snackbar,
  CircularProgress,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { Column } from "primereact/column";
import { toast } from "react-toastify";
import Tables from "./widgets/tables";
import { useDispatch, useSelector } from "react-redux";
import {
  ApproveCashoutSlice,
  CashoutSlice,
  setFilters,
  setPage,
  setRowsPerPage,
} from "../redux/slices/cashouts";
import moment from "moment/moment";
import { getUserData, RightOffCash } from "../redux/slices/offcanvas";
import { tabsSuccess } from "../redux/slices/tabs";
import { keyframes } from "@emotion/react";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import DownloadData from "./widgets/downloaddata";
import ButtonTabs from "./widgets/buttontabs";
import DoneIcon from "@mui/icons-material/Done";
import CancelIcon from "@mui/icons-material/Cancel";
import { ablyClient } from "../lib/socket";
import LazyTable from "./widgets/lazytable";
// Define rotation animation
const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const CashoutRequests = () => {
  const dispatch = useDispatch();
  const { page, data, rowsPerPage, totalCashouts, loading, filters } =
    useSelector((v) => v.cashouts);
  const userData = useSelector((v) => v.login.user);
  const fetchCashoutData = () => {
    dispatch(CashoutSlice(page, rowsPerPage, filters));
  };
  const [imageUrl, setImageUrl] = useState(null);
  const [zoom, setZoom] = useState(1);
  const [openImageDialog, setOpenImageDialog] = useState(false);

  const handleViewImage = (rowData) => {
    if (rowData?.attachments) {
      setImageUrl(rowData?.attachments);
      setOpenImageDialog(true);
    }
  };

  useEffect(() => {
    fetchCashoutData();
  }, [dispatch, page, rowsPerPage, filters]);

  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleApprove = async (data, paths, index) => {
    const params = Object.assign({}, data, { action: "radeem" });
    await dispatch(RightOffCash(params));

    const payload = {
      uid: params?.userid,
      cid: params?._id,
    };
    if (paths === "approve") {
      dispatch(tabsSuccess("approve"));
    } else if (paths === "rejected") {
      dispatch(tabsSuccess("rejected"));
    }

    await dispatch(getUserData(payload));
  };

  const headers = [
    "#",
    // "User ID",
    "User Name",
    "Payment Method",
    "User Balance",
    "Amount",
    "Date",
  ];

  const tableData = data?.map((row, index) => [
    index + 1,
    // row.userid,
    row.username,
    row.cam,

    `$${row?.balance}`,
    `$${row?.amount}`,
    moment(row?.createdAt).format("L"),
  ]);

  useEffect(() => {
    const channel = ablyClient.channels.get("admin-cashout");

    const messageHandler = async (message) => {
      const { senderId, receiverId, text } = message.data;

      if (senderId) {
        // setMessages((prev) => [...prev, { senderId, receiverId, text }]);
        fetchCashoutData();
      }
    };

    channel.subscribe("private-cash", messageHandler);

    return () => {
      channel.unsubscribe("private-cash", messageHandler);
    };
  }, []);

  const handleChangePage = (event, newPage) => {
    dispatch(setPage(newPage));
  };

  const handleChangeRowsPerPage = (event) => {
    dispatch(setRowsPerPage(event.target.value, 10));
    dispatch(setPage(0));
  };

  const statusBodyTemplate = (rowData) => {
    let color, icon, statusText;
    if (rowData.status === "paid") {
      color = "#4CAF50";
      statusText = "Approved";

      icon = (
        <>
          <DoneIcon sx={{ color: "white", fontSize: "16px" }} />
        </>
      );
    } else if (rowData.status === "rejected") {
      color = "red";
      statusText = "Rejected";
      icon = (
        <>
          <CancelIcon sx={{ color: "white", fontSize: "16px" }} />
        </>
      );
    } else if (rowData.status === "deposit") {
      color = "#4CAF50";
      statusText = "Approved";

      icon = (
        <>
          <DoneIcon sx={{ color: "white", fontSize: "16px" }} />
        </>
      );
    } else {
      color = "#FFC104";
      statusText = "Pending";
      icon = (
        <>
          <DoneIcon sx={{ color: "white", fontSize: "16px" }} />
        </>
      );
    }

    return (
      <div className="flex justify-start items-center">
        <Box
          className="mr-2"
          sx={{
            width: 24,
            height: 24,
            borderRadius: "50%",
            backgroundColor: color,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {icon}{" "}
        </Box>

        {rowData.status === "paid"
          ? "Done"
          : rowData.status === "deposit"
          ? "Done"
          : rowData.status === "rejected"
          ? "Reject"
          : "Pending"}
      </div>
    );
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          my: 4,
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography variant="h5" sx={{ marginBottom: 0 }}>
            Cashout Requests
          </Typography>
          <IconButton
            onClick={fetchCashoutData}
            disabled={loading}
            sx={{
              animation: loading ? `${rotate} 1s linear infinite` : "none",
              backgroundColor: "#3f51b5",
              color: "white",
              "&:hover": {
                backgroundColor: "#303f9f",
              },
              "&:disabled": {
                backgroundColor: "#e0e0e0",
              },
            }}
          >
            <RefreshIcon />
          </IconButton>
        </Box>
        <DownloadData
          headers={headers || []}
          tableData={tableData || []}
          fileName={"Cashout-requests"}
        />
      </Box>
      {/* <Box>
        <ButtonTabs />
      </Box> */}
      {/* Snackbar for Export */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        message="Please select an export format."
        onClose={() => setOpenSnackbar(false)}
      />

      <LazyTable
        data={data}
        page={page}
        rowsPerPage={rowsPerPage}
        totalRecords={totalCashouts}
        loading={loading}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        onFilterChange={(filters) => {
          dispatch(setFilters(filters));
        }}
        columns={[
          { field: "username", headerName: "User Name", filter: true },
          {
            field: "balance",
            headerName: "Balance",
            filter: true,
          },
          {
            field: "amount",
            headerName: "Amount",
            filter: true,
          },
          {
            field: "cam",
            headerName: "Payment Method",
            filter: true,
            render: (rowData) =>
              rowData?.cam && (
                <span className="capitalize">{rowData?.cam}</span>
              ),
          },
          {
            field: "createdAt",
            headerName: "Date",
            filter: true,
            render: (rowData) => moment(rowData?.createdAt).format("L LT"),
          },
          {
            field: "active",
            headerName: "Status",
            filter: true,
            render: statusBodyTemplate,
          },
          {
            field: "attachment",
            headerName: "Attachment",
            render: (rowData) =>
              rowData.status !== "approved" && rowData.status !== "rejected" ? (
                <Button
                  variant="text"
                  onClick={() => handleViewImage(rowData)}
                  sx={{ textDecoration: "underline", padding: 0 }}
                >
                  View
                </Button>
              ) : (
                <Button
                  variant="text"
                  onClick={() => handleViewImage(rowData)}
                  sx={{ textDecoration: "underline", padding: 0 }}
                >
                  View
                </Button>
              ),
          },
          {
            field: "actions",
            headerName: "Actions",
            render: (rowData, index) =>
              rowData?.status != "paid" ? (
                <Box display="flex" gap={1}>
                  <Button
                    variant="contained"
                    color="success"
                    size="small"
                    onClick={() => handleApprove(rowData, "approve", index)}
                  >
                    <span className="text-white">Approve</span>
                  </Button>

                  {rowData?.status != "rejected" && (
                    <Button
                      variant="contained"
                      color="error"
                      size="small"
                      onClick={() => handleApprove(rowData, "rejected", index)}
                    >
                      Reject
                    </Button>
                  )}
                </Box>
              ) : null,
          },
        ]}
      />

      {/* PrimeReact DataTable */}
      {/* <Tables rowData={rowData}>
        <Column
          header="#"
          body={(rowData, options) => options.rowIndex + 1}
          filter
          filterPlaceholder="Search by SrNo"
        />

        <Column
          field="username"
          header="User Name"
          filter
          filterPlaceholder="Search by User Name"
        />
        <Column
          field="balance"
          header="Balance"
          filter
          body={(rowData) => `$${rowData?.balance}`}
          filterPlaceholder="Search by Balance"
        />
        <Column
          field="amount"
          header="Amount"
          filter
          body={(rowData) => `$${rowData?.amount}`}
          filterPlaceholder="Search by Amount"
        />
        <Column
          field="cam"
          header="Payment Method"
          filter
          body={(rowData) =>
            rowData?.cam && <span className="capitalize">{rowData?.cam}</span>
          }
          filterPlaceholder="Search by Payment"
        />
        <Column
          field="createdAt"
          header="Date"
          filter
          body={(rowData) => moment(rowData?.createdAt).format("L LT")}
          filterPlaceholder="Search by Date"
        />
        <Column
          field="active"
          header="Status"
          filter
          filterPlaceholder="Search by Status"
          body={statusBodyTemplate}
        />

        <Column
          header="Attachment"
          body={(rowData) =>
            rowData.status !== "approved" && rowData.status !== "rejected" ? (
              <Button
                variant="text"
                onClick={() => handleViewImage(rowData)}
                sx={{ textDecoration: "underline", padding: 0 }}
              >
                View
              </Button>
            ) : (
              <Button
                variant="text"
                onClick={() => handleViewImage(rowData)}
                sx={{ textDecoration: "underline", padding: 0 }}
              >
                View
              </Button>
            )
          }
        />

        <Column
          header="Action"
          body={(rowData, index) =>
            rowData?.status != "paid" ? (
              <Box display="flex" gap={1}>
                <Button
                  variant="contained"
                  color="success"
                  size="small"
                  onClick={() => handleApprove(rowData, "approve", index)}
                >
                  {loadingIndex === index ? (
                    <CircularProgress size={20} />
                  ) : (
                    <span className="text-white">Approve</span>
                  )}
                </Button>

                {rowData?.status != "rejected" && (
                  <Button
                    variant="contained"
                    color="error"
                    size="small"
                    onClick={() => handleApprove(rowData, "rejected", index)}
                  >
                    Reject
                  </Button>
                )}
              </Box>
            ) : null
          }
        />
      </Tables> */}
      <Dialog
        open={openImageDialog}
        onClose={() => setOpenImageDialog(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>View Attachment</DialogTitle>
        <DialogContent>
          {imageUrl && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "400px",
                overflow: "hidden",
              }}
            >
              {imageUrl?.map((img, index) => (
                <img
                  src={img?.image}
                  alt="Attachment"
                  style={{
                    transform: `scale(${zoom})`,
                    transition: "transform 0.3s ease-in-out",
                    maxWidth: "100%",
                    maxHeight: "100%",
                  }}
                />
              ))}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setZoom(zoom - 0.1)} disabled={zoom <= 0.5}>
            Zoom Out
          </Button>
          <Button onClick={() => setZoom(zoom + 0.1)} disabled={zoom >= 2}>
            Zoom In
          </Button>
          <Button onClick={() => setOpenImageDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CashoutRequests;
